<template>
	<div class="left">
		<div class="title">
			服务导向
		</div>
		
		<div class="opt_box">
			<div class="opt_min" @click="dao(0)">
				怎样到景区
			</div>
			<div class="opt_min" @click="dao(1)">
				游玩线路
			</div>
			<div class="opt_min" @click="dao(2)">
				购物指南
			</div>
			<div class="opt_min" @click="dao(3)">
				餐饮美食
			</div>
			<div class="opt_min" @click="dao(4)">
				酒店住宿
			</div>
			<div class="opt_min" @click="dao(5)">
				特色文创
			</div>
		</div>
		
		<div class="er_box">
			<div class="er_text">
				扫码预约景区
			</div>
			
			<img class="erwei" src="../static/home/erwei.jpg" alt="" />
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods:{
			dao(e){
				if(e==0){
					this.$router.push({name:'guide',query:{num:2}})
				}
				if(e==1){
					this.$router.push({name:'guide',query:{num:3}})
				}
				if(e==2){
					this.$router.push({name:'guide',query:{num:4}})
				}
				if(e==3){
					this.$router.push({name:'guide',query:{num:0}})
				}
				if(e==4){
					this.$router.push({name:'guide',query:{num:1}})
				}
				if(e==5){
					this.$router.push({name:'memorial',query:{num:5}})
				}
			}
			
		}
	}
</script>

<style scoped lang="less">
	.left{
		width: 202px;
		height: 357px;
		position: absolute;
		top: 50%;
		left: 0;
		z-index: 10;
		transform: translateY(-50%);
		background-image: url('../static/home/left.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		
		color: #24321e;
		
		animation:  left_ain 3s linear;
		animation-fill-mode: forwards;
	}
		@keyframes left_ain {
			0%{
				opacity: 0;
				transform: scale(0.5) translateY(-50%);
			}
			100%{
				opacity: 1;
				transform: scale(1) translateY(-50%);
			}
		}
		
	
	// 
	.title{
		width: 145px;
		height: 45px;
		line-height: 45px;
		text-align: center;
		font-size: 18px;
		
		position: absolute;
		top: 5px;
		left: 16px;
	}
	
	// 
	.opt_box{
		height: 85px;
		width: 138px;
		border-bottom: 1px solid #9fa486;
		
		position: absolute;
		top: 69px;
		left: 29px;
		
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}
	.opt_min{
		font-size: 12px;
		cursor:pointer;
	}
		.opt_min:hover{
			color: #fff;
		}
	// 
	.er_box{
		width: 109px;
		position: absolute;
		top: 175px;
		left: 58px;
	}
	.er_text{
		font-size: 12px;
		text-align: center;
		letter-spacing: 4px;
		white-space: nowrap;
	}
	.erwei{
		width: 109px;
		height: 110px;
		object-fit: cover;
		margin-top: 10px;
	}
	
	
	
</style>